import { useMemo } from "react";
import { getPermissions } from "../../utils/app.utils";

export type MenuPermission = {
  isView: boolean;
  isCreate: boolean;
  isUpdate: boolean;
  isDelete: boolean;
  isExport: boolean;
  /** สะกดผิดตั้งแต่ backend — ต้องใช้ตามนี้ ไม่ทำ alias ที่สะกดถูก จะกลายเป็นสอง source */
  isApporve: boolean;
};

/**
 * อ่านสิทธิ์ของเมนูจากลิสต์เมนูใน PERMISSION โดยตรง ไม่พึ่ง activeMenu
 *
 * ทำไมไม่ใช้ isView()/isApporve() จาก utils/permission.utils เหมือนหน้าอื่น:
 * PrivateRoute (App.tsx) เขียน activeMenu ลง localStorage ระหว่าง render และ render รอบแรก
 * menuPermissions ยังเป็น [] ทำให้ _.find คืน undefined จากนั้น JSON.stringify ตัด key
 * activeMenu ทิ้งทั้ง key — สิทธิ์จึงหายไปชั่วคราว ปุ่มจางจนกว่าจะ render รอบใหม่หรือ reload
 *
 * ลิสต์เมนู (key ตัวเลข) ไม่ได้ถูกแก้ในจังหวะนั้น จึงอ่านจากตรงนั้นแล้วเทียบด้วย menuFirstKey
 * ที่หน้าส่งเข้ามา ได้ค่าที่ถูกตั้งแต่ render แรก
 *
 * รับ menuKey เป็น parameter เพราะเมนูคืนค่ามัดจำมี 2 ฝั่ง (เจ้าหน้าที่ / ผู้เช่า)
 * ที่ใช้สิทธิ์คนละ row กัน แต่ใช้ hook ตัวเดียวกัน
 */
export const useMenuPermission = (menuKey: string): MenuPermission =>
  useMemo(() => {
    const permissions: any = getPermissions() || {};
    const { activeMenu, ...menus } = permissions;

    const ownMenu: any = Object.values(menus).find(
      (menu: any) => menu?.menuFirstKey === menuKey
    );

    // activeMenu เป็นทางสำรอง เผื่อ PERMISSION ถูกเก็บในรูปที่ไม่มีลิสต์เมนู
    const source: any = ownMenu || activeMenu || {};

    return {
      isView: !!source.isView,
      isCreate: !!source.isCreate,
      isUpdate: !!source.isUpdate,
      isDelete: !!source.isDelete,
      isExport: !!source.isExport,
      isApporve: !!source.isApporve,
    };
    // สิทธิ์ถูก cache ตอน login ไม่เปลี่ยนระหว่างอยู่ในหน้า อ่านครั้งเดียวพอ
  }, [menuKey]);
